import React from 'react';
import Badge from '../common2/Badge';

function BooleanBadge({ value }) {
  return value ?
    <Badge intent="positive">Yes</Badge> :
    <Badge intent="alert">No</Badge>;
}

export default React.memo(BooleanBadge);